import { render, staticRenderFns } from "./ItemPlanner.vue?vue&type=template&id=1d4f183c&scoped=true&"
import script from "./ItemPlanner.vue?vue&type=script&lang=js&"
export * from "./ItemPlanner.vue?vue&type=script&lang=js&"
import style0 from "./ItemPlanner.vue?vue&type=style&index=0&id=1d4f183c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4f183c",
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardText, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardText, BCard})
    

export default component.exports